<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout">
    {{ translation(text) }}
    <v-btn dark flat
      @click="snackbar = false">
      {{ translation('snackbar.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['translation']),
    snackbar: {
      get () { return this.$store.getters.snackbar },
      set (val) { this.$store.commit('SET_SNACKBAR', val) }
    },
    text: { get () { return this.$store.getters.snackbarText } },
    timeout: { get () { return this.$store.getters.snackbarTimeout } }
  }
}
</script>
